import type { ElementType } from 'react'
import type { Role } from '../typings'
import { OnboardingRoles } from '../typings'
import { EducatorStep } from './EducatorStep'
import { PersonalStep } from './PersonalStep'
import { ProfessionalStep } from './ProfessionalStep'
import type { StepProps } from './StepProps'
import { StudentStep } from './StudentStep'

export function getStepForRole(role: Role | null): ElementType<StepProps> {
  switch (role) {
    case OnboardingRoles.student: {
      return StudentStep
    }
    case OnboardingRoles.educator: {
      return EducatorStep
    }
    case OnboardingRoles.personal: {
      return PersonalStep
    }
    case OnboardingRoles.professional: {
      return ProfessionalStep
    }
    default:
      return PassThroughStep
  }
}

export function PassThroughStep() {
  return <></>
}
